import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Container, Tab } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import MarkeetTab from './Markeet'
import PortFolioTab from './Portfolio'

export default function Investments() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [value, setValue] = React.useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <Container maxWidth="xl">
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              onChange={handleChange}
              aria-label="investments"
              sx={{
                '.MuiTabs-flexContainer': { justifyContent: 'start', gap: 2 },
                '.MuiButtonBase-root': { color: 'white' },
                '.Mui-selected': { color: '#1976d2' },
              }}
            >
              {/* LAP-733 (GE022) */}
              <Tab label={t('investments.tabs.market')} value="1" />
              <Tab label={t('investments.tabs.portfolio')} value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0 }}>
            <MarkeetTab />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0 }}>
            <PortFolioTab />
          </TabPanel>
        </TabContext>
      </Container>
    </Box>
  )
}
